/* ------------------------------------------------
Import Modules
------------------------------------------------ */

import ScrollToTopController from 'scripts/marmalade/classes/scroll-to-top';

/* ------------------------------------------------
Page Setup
------------------------------------------------ */

// Create ScrollToTopController instance
const ScrollToTop = new ScrollToTopController();
// When the controller is clicked, scroll to the top of the page
ScrollToTop.on('click', () => ScrollController.scrollTo(0));